import React, {
  useMemo,
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
  useEffect
} from "react";
import { Select, message, Modal } from "antd";
import Avatar from "../Avatar";
import Icon from "../../Icon";
import {
  getJoySpaceDelPermission,
  getJoySpaceReadAllPermission,
  getJoySpaceReadNothingPermission,
  getJoySpaceReadOnlyPermission,
  getJoySpaceReadWritePermission,
  joyspacePermissionType
} from "../../config/permissions.config";
import {
  getFolderMenus,
  getFolderAllMenus,
  SelectType,
  getPageMenusAll,
  getPageMenus
} from "./config";
import "./index.less";
import { FileType } from "../../types";
const { Option } = Select;
interface IProps {
  type?: FileType; // 判断是文件还是文件夹
  permissionType: joyspacePermissionType;
  onClick?: Function;
  onChange?: Function;
  onlyText?: Boolean; // 是否为全部权限设置
  isDisableAll?: Boolean; // 是否为全部权限设置
  isCheckAll?: Boolean; // 是否为全部权限设置
  propsValue?: string;
  isOnlyText?: Boolean;
  isShowDelMenu?: Boolean;
  ownerNum?: number;
  isLoginUser?: Boolean;
}

const PermissionSelect = (props: IProps) => {
  const {
    type = FileType.Page, // 判断是文件还是文件夹
    permissionType = getJoySpaceReadOnlyPermission(),
    isDisableAll = false,
    onClick,
    onChange,
    propsValue,
    isCheckAll = false,
    isOnlyText,
    isShowDelMenu = false,
    ownerNum = 0,
    isLoginUser = false
  } = props;
  const [value, setValue] = useState(propsValue);
  const [onlyText, setOnlyText] = useState(isOnlyText ?? false);
  const [menus, setMenus] = useState([]);
  const getDelMenu = useCallback(() => {
    if (isShowDelMenu) {
      return {
        title: "删除",
        tip:
          type === FileType.Page ? "删除文档权限" : "删除文档权限和文件夹权限",
        permissions: getJoySpaceDelPermission()
      };
    }
  }, [isShowDelMenu, type]);
  useEffect(() => {
    let useMenus: any[] = [];

    if (isCheckAll && type === FileType.Folder) {
      useMenus = getFolderAllMenus();
    }
    if (!isCheckAll && type === FileType.Folder) {
      useMenus = getFolderMenus();
    }
    if (isCheckAll && type === FileType.Page) {
      useMenus = getPageMenusAll();
    }
    if (!isCheckAll && type === FileType.Page) {
      useMenus = getPageMenus();
    }
    useMenus = useMenus.filter((item) => {
      if (
        item.permissions < permissionType ||
        (isLoginUser &&
          (value as any) === getJoySpaceReadAllPermission() &&
          (item.permissions === getJoySpaceReadOnlyPermission() ||
            item.permissions === getJoySpaceReadWritePermission()))
      ) {
        return false;
      }
      return true;
    });
    // 增加移除按钮
    if (!isCheckAll && isShowDelMenu && permissionType <= Number(value)) {
      useMenus.push(getDelMenu());
    }
    // console.log(useMenus, 'useMenususeMenususeMenususeMenus');
    // @ts-ignore
    setMenus(useMenus);
  }, [isCheckAll, type, permissionType, getDelMenu, value, isShowDelMenu, isLoginUser]);
  const getPermissionText = useCallback(
    (permission) => {
      for (const item of menus) {
        if (permission === (item as any).permissions) {
          return (item as any)?.title;
        }
      }
      if (permission === getJoySpaceReadWritePermission()) {
        return "可编辑";
      }
      if (permission === getJoySpaceReadAllPermission()) {
        return "可管理";
      }
      return;
    },
    [menus]
  );
  useEffect(() => {
    isOnlyText !== undefined && setOnlyText(isOnlyText);
  }, [isOnlyText]);
  // useEffect(() => {
  //   if (!isLoginUser && permissionType === getJoySpaceReadOnlyPermission()) {
  //     setOnlyText(true);
  //   }
  // }, [permissionType, isLoginUser]);
  useEffect(() => {
    setValue(propsValue);
  }, [propsValue]);

  const onChangeHandle = useCallback(
    (values: any) => {
      onChange?.(values);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, setValue]
  );
  // console.log(onlyText, isCheckAll, 'isCheckAll=====>');
  if (onlyText && isCheckAll) {
    return (
      <Select
        size="small"
        value={value}
        defaultValue="批量设置权限"
        dropdownMatchSelectWidth={false}
        // onChange={(values) => {
        //     onChangeHandle?.(values);
        // }}
        onSelect={(value) => {
          // onChangeHandle?.(value);
        }}
        className="joyspace-permission-select"
      >
        {(menus as any[]).map((_item, _index) => {
          return (
            <Option
              key={_index}
              value={_item.permissions}
              className="joyspace-permission-select-option"
            >
              {_item.title}
              <p className="permission-select-tip">{_item.tip}</p>
            </Option>
          );
        })}
      </Select>
    );
  }
  if (
    onlyText ||
    (ownerNum === 1 && (value as any) === getJoySpaceReadAllPermission()) ||
    type === FileType.Page && (value as any) === getJoySpaceReadAllPermission() || // 因继承导致文档有多个可管理，文档可管理不支持修改
    permissionType === getJoySpaceReadNothingPermission()
  ) {
    return (
      <span className="joyspace-select-only-text">
        {
          // @ts-ignore
          getPermissionText(propsValue ?? permissionType)
        }
      </span>
    );
  }
  if (typeof propsValue !== "undefined") {
    return (
      <Select
        size="small"
        value={value}
        defaultValue="批量设置权限"
        dropdownMatchSelectWidth={false}
        // onChange={(values) => {
        //     onChangeHandle?.(values);
        // }}
        onSelect={(value) => {
          onChangeHandle?.(value);
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className="joyspace-permission-select"
      >
        {(menus as any[]).map((_item, _index) => {
          if (isDisableAll && !isCheckAll && _item.permissions === getJoySpaceReadAllPermission()) {
            return null;
          }
          return (
            <Option
              key={_index}
              value={_item.permissions}
              disabled={
                isDisableAll && _item.permissions === getJoySpaceReadAllPermission() ? true : false
              }
              className="joyspace-permission-select-option"
            >
              {_item.title}
              <p className="permission-select-tip">{_item.tip}</p>
            </Option>
          );
        })}
      </Select>
    );
  }
  return (
    <Select
      size="small"
      defaultValue="批量设置权限"
      dropdownMatchSelectWidth={false}
      onSelect={(value) => {
        onChangeHandle?.(value);
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="joyspace-permission-select"
    >
      {(menus as any[]).map((_item, _index) => {
        if (isDisableAll && !isCheckAll && _item.permissions === getJoySpaceReadAllPermission()) {
          return null;
        }
        return (
          <Option
            key={_index}
            value={_item.permissions}
            disabled={
              isDisableAll && _item.permissions === getJoySpaceReadAllPermission() ? true : false
            }
            className="joyspace-permission-select-option"
          >
            {_item.title}
            <p className="permission-select-tip">{_item.tip}</p>
          </Option>
        );
      })}
    </Select>
  );
};
export default PermissionSelect;
